import React from 'react';

import useMartyContext from 'hooks/useMartyContext';
import Breadcrumbs from 'components/common/Breadcrumbs';

import css from 'styles/components/account/accountBreadcrumbs.scss';

const AccountBreadcrumbs = ({ links = [], ...rest }) => {
  const { testId } = useMartyContext();
  const accountOverviewBreadcrumb = {
    'to': '/account',
    'data-test-id': testId('accountOverviewBreadcrumb'),
    'text': 'Account Overview'
  };
  const accountLinks = [accountOverviewBreadcrumb, ...links];
  return <Breadcrumbs links={accountLinks} className={css.accountBreadcrumbs} {...rest} />;
};

export default AccountBreadcrumbs;
